module.exports = (function($) {
    /**
     * LocationMap constructor
     * 
     * @param {Element}                         mapElement  
     * @param {google.maps.places.Autocomplete} autocomplete 
     * 
     * @see https://developers.google.com/maps/documentation/javascript/reference/places-widget#Autocomplete
     */
    const LocationMap = function(mapElement, autocomplete) {
        this.initialCenter = new google.maps.LatLng(site_data.MAP_CENTER_LAT,site_data.MAP_CENTER_LNG);
        this.initialZoom = 12;
        this.maxZoom = 18;
        this.mapElement = mapElement;
        this.autocomplete = autocomplete;
        this.map = null;
        this.locations = [];
        this.locationMarkers = [];
        this.mapContainClass = 'section-map__map';
        this.locationForm = document.getElementById('location-form');
        this.mfcuATMsCheckbox = document.querySelector('.map-filters #atms');
        this.coopATMsCheckbox = document.querySelector('.map-filters #coop-atms');
        this.onlyDepositATMsCheckbox = document.querySelector('.map-filters #deposit-atms');
        this.mapListContain = document.querySelector('ul.map-list');
        this.mapCenterLat = site_data.MAP_CENTER_LAT;
        this.mapCenterLng = site_data.MAP_CENTER_LNG;
        this.userLat = null;
        this.userLng = null;
        this.userMarker = null;
        this.icons = {
            // Default marker off
            pinOff: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-pin-off.svg',
                new google.maps.Size(26, 40), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(0, 40), //anchor
                new google.maps.Size(26, 40) //scaled size
            ),
            // Default marker on
            pinOn: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-pin-on.svg',
                new google.maps.Size(26, 40), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(0, 40), //anchor
                new google.maps.Size(26, 40) //scaled size
            ),
            // Branch marker off
            branchOff: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-branch-pin-off.svg',
                new google.maps.Size(26, 40), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(0, 40), //anchor
                new google.maps.Size(26, 40) //scaled size
            ),
            // Branch marker on
            branchOn: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-branch-pin-on.svg',
                new google.maps.Size(26, 40), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(0, 40), //anchor
                new google.maps.Size(26, 40) //scaled size
            ),
            // User location
            user: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-user-pin.svg',
                new google.maps.Size(26, 40), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(0, 40), //anchor
                new google.maps.Size(26, 40) //scaled size
            ),
        };
    };

    /**
     * Initializes the Google map on the page, adds initial markers,
     * and sets up event handlers for various user interactions to
     * update the list of locations displayed.
     * 
     * @param {boolean} controls If map controls should be displayed
     */
    LocationMap.prototype.initMap = function(controls){
        const self = this;
        // Map arguments
        const args = {
            zoom:              this.initialZoom,
            maxZoom:           this.maxZoom,
            center:            this.initialCenter,
            mapTypeId:         google.maps.MapTypeId.ROADMAP,
            mapTypeControl:    false,
            rotateControl:     false,
            fullscreenControl: false,
            streetViewControl: false,
            disableDefaultUI:  controls === false ? true : false,
            styles:            this.mapStyles
        };

        // Set initial user location in localStorage
        self.updateUserLocationLocalStorage();

        // Create map and store it for future reference
        self.map = new google.maps.Map(this.mapElement, args);

        // Get initial markers
        self.fetchLocations(true);

        // Trigger fetch of locations when map filters change
        self.mfcuATMsCheckbox.addEventListener('change', () => {self.fetchLocations()});
        self.coopATMsCheckbox.addEventListener('change', () => {self.fetchLocations()});
        self.onlyDepositATMsCheckbox.addEventListener('change', () => {self.fetchLocations()});

        // Prevent search form from being submitted directly.
        // Users must select an option from the autocomplete field or
        // click use my location to update their location
        self.locationForm.addEventListener('submit', (event) => {
            event.preventDefault();
        });

        // When autocomplete place changes, update user location
        self.autocomplete.addListener('place_changed', () => {
            const place = self.autocomplete.getPlace();

            if (place?.geometry?.location) {
                self.setUserLocation(
                    place.geometry.location.lat(),
                    place.geometry.location.lng()
                );
            } else {
                alert('Please select an address from the provided suggestions.');
                console.log(`No location data available for input: "${place.name}"`);
            }
        });

        // Add click handler to use location button if supported, otherwise hide
        if (navigator.geolocation) {
            $('.use-loc').on('click',function(e){
                e.preventDefault();
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        self.setUserLocation(
                            position.coords.latitude,
                            position.coords.longitude
                        );
                    },
                    (error) => {
                        console.warn(`ERROR(${error.code}): ${error.message}`);
                        self.userLat = null;
                        self.userLng = null;
                        self.updateUserLocationLocalStorage();
                        self.updateUserMarker();
                        $('#loc_address').val('');
                        self.fetchLocations();
                    },
                    {enableHighAccuracy: true, timeout: 5000}
                );

            });
        } else {
            $('.use-loc').hide();
        }

        // When user pans map, change map center and fetch locations
        self.map.addListener('idle', () => {
            const mapCenter = self.map.getCenter();
            if (mapCenter.lat() !== self.mapCenterLat || mapCenter.lng() !== self.mapCenterLng) {
                self.setMapCenterCoords(mapCenter.lat(), mapCenter.lng());
                // Only re-fetch locations if we're displaying Co-Op ATMs
                if (self.coopATMsCheckbox.checked) {
                    self.fetchLocations();
                }
            }
        });

    };

    /**
     * Fetches updated list of locations, refreshes markers and
     * location list.
     * 
     * @param {boolean} initialLoad If this is the initial map load, when the
     *                              bounds should extend to contain all markers
     */
    LocationMap.prototype.fetchLocations = function(initialLoad = false) {
        const self = this;

        // Parse map filters and fetch location data
        const params = new URLSearchParams({
            action: 'get_location_map_data',
            show_coop_atms: this.coopATMsCheckbox.checked ? 1 : 0,
            show_mfcu_atms: this.mfcuATMsCheckbox.checked ? 1 : 0,
            only_deposit_accepting: this.onlyDepositATMsCheckbox.checked ? 1 : 0,
            map_center_lat: this.mapCenterLat,
            map_center_lng: this.mapCenterLng,
        });
        
        if (this.userLat !== null && this.userLng !== null) {
            params.set('user_lat', this.userLat);
            params.set('user_lng', this.userLng);
        }
        
        fetch(`${site_data.WP_AJAX}?${params}`)
            .then(response => response.json())
            .then(response => {
                if (!response.success) {
                    throw new Error(response.errors.join(', '));
                }

                self.locations = response.locations;
                // Replace locations list
                const newMapListContent = self.locations.reduce(
                    (html, location) => {
                        html += location.markup ?? '';
                        return html
                    },
                    ''
                );
                self.mapListContain.innerHTML = newMapListContent;
                // Re-init markers
                self.removeMarkers();
                self.generateMarkers(initialLoad);
            })
            .catch(error => console.log('Unable to fetch updated locations', error));
    };

    /**
     * Removes all markers currently displayed on the map.
     */
    LocationMap.prototype.removeMarkers = function () {
        this.locationMarkers.forEach(marker => {
            marker.setMap(null);
        });
        this.locationMarkers = [];
    };

    /**
     * Adds markers to the map based on markup in the location list.
     * Optionally extends the bounds of the map to fit all markers.
     * 
     * @param {boolean} initialLoad If this is the initial map load, when the
     *                              bounds should extend to contain all markers
     */
    LocationMap.prototype.generateMarkers = function (initialLoad = false) {
        const self = this;
        const $markers = $('.map-marker');
        const bounds = new google.maps.LatLngBounds();

        //loop through the markers to set them
        $markers.each(function(index, element){

            const $loc = $(this);
            const locId = $(this).data('id');
            const lat = $(this).data('lat');
            const lng = $(this).data('lng');
            const icon = $(this).hasClass('location') ? 'map-branch-pin-off' : 'map-pin-off'; //determine starting icon

            // Marker coordinates
            const latlng = new google.maps.LatLng(lat, lng);
            
            // create marker
            const marker = new google.maps.Marker({
                position: latlng,
                map: self.map,
                optimized: false,
                icon: {
                    url: site_data.THEME_URL + `/img/${icon}.svg`,
                    size: new google.maps.Size(26, 40),
                    scaledSize: new google.maps.Size(26, 40),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(0, 40),
                },
                animation: google.maps.Animation.DROP
            });

            if (initialLoad) {
                self.map.setCenter(marker.position);

                // extend maps bounds to include markers
                bounds.extend(marker.position);
                self.map.fitBounds(bounds);
            }

            //add marker to markers array
            self.locationMarkers.push(marker);

            // MARKER CLICK
            marker.addListener('click', function() {
                
                //if marker not already set to active
                if( !$(`.map-marker[data-id='${locId}']`).find('.map-marker__details').is(":visible") ){

                    //toggle correct map marker
                    setMarkerIcon(self.locationMarkers, marker);
                    
                    //close all list items
                    $('.map-marker').each(function(){
                        $(this).removeClass('map-marker--on');
                        $(this).find('.map-marker__details').slideUp();
                    });
                    //expand list item
                    $(`.map-marker[data-id='${locId}']`)
                        .find('.map-marker__details')
                        .slideDown(
                            400,
                            (locationDetails) => {
                                //mobile - hide map, open list
                                $('.section-map__map').removeClass('open');
                                $('.section-map__list').addClass('open');

                                //scroll to the selected list item
                                const $scrollList = $('.section-map__list > ul.map-list');
                                const listItem = $(`.map-marker[data-id='${locId}']`);

                                $scrollList.animate({
                                    scrollTop: $scrollList.scrollTop() - $scrollList.offset().top + listItem.offset().top
                                },500);
                            }
                        );
                        $(`.map-marker[data-id='${locId}']`).addClass('map-marker--on');
                }

            });

        }); //endfor each marker

        //CLICK LIST ITEM TITLE - EXPAND DETAILS AND ACTIVE MARKER
        $('.js-toggle-loc').on({
            click: function(e){
                const listingId = $(this).closest('.map-marker').data('id');
                const index = $(this).closest('.map-marker').index();
                
                //if clicked item is not already visible
                if( !$(this).closest('.map-marker').find('.map-marker__details').is(":visible") ){
                    $('.map-marker').each(function(){
                        $(this).removeClass('map-marker--on');
                        let $details =  $(this).find('.map-marker__details');
                        $details.slideUp();
                        $details.attr("aria-expanded", "false");
                    });
                    let $details =  $(this).closest('.map-marker').find('.map-marker__details');
                    $details.slideDown();
                    $details.attr("aria-expanded", "true");
                    $(this).closest('.map-marker').addClass('map-marker--on');

                    //toggle correct map marker
                    setMarkerIcon(self.locationMarkers, self.locationMarkers[index]);
                }

            }
        });

        // set marker icon 
        //Params: array of all marker objects and the marker object to set as "ON"
        const setMarkerIcon = (locationMarkers, setMarker) => {
            //loop through all markers and turn them off
            for (let j = 0; j < locationMarkers.length; j++) {
                //if the markers icon is the default set it to defaul off
                if( locationMarkers[j].icon.url == site_data.THEME_URL + '/img/map-pin-on.svg' ){
                    locationMarkers[j].setIcon(self.icons.pinOff);
                }
                //else if the markers icon is branch set it to branch off
                else if( locationMarkers[j].icon.url == site_data.THEME_URL + '/img/map-branch-pin-on.svg' ){
                    locationMarkers[j].setIcon(self.icons.branchOff);
                }
            }

            //if set marker is a branch pin et it to branch on
            if( setMarker.icon.url == site_data.THEME_URL + '/img/map-branch-pin-off.svg' ){
                setMarker.setIcon(self.icons.branchOn);
            }
            else{
                //else set it do default on
                setMarker.setIcon(self.icons.pinOn);
            }
        }
    };

    /**
     * Sets the user's lat/lng, used to determine distance when fetching location data.
     * 
     * @param {number} lat 
     * @param {number} lng 
     */
    LocationMap.prototype.setUserLocation = function (lat, lng) {
        this.userLat = lat;
        this.userLng = lng;
        this.updateUserLocationLocalStorage();
        this.updateUserMarker();
        this.mapCenterLat = lat;
        this.mapCenterLng = lng;
        this.map.setCenter({lat: lat, lng: lng});
        this.fetchLocations();
    };

    /**
     * Updates the user's lat and lng in localStorage based on the current
     * value of the related properties in this object. Used to calculate
     * a user's distance from a location when viewing that location's details
     * page.
     */
    LocationMap.prototype.updateUserLocationLocalStorage = function () {
        if (this.userLat === null || this.userLng === null) {
            localStorage.removeItem('userLocationLat');
            localStorage.removeItem('userLocationLng');
        } else {
            localStorage.setItem('userLocationLat', this.userLat);
            localStorage.setItem('userLocationLng', this.userLng);
        }
    };

    /**
     * Adds/updates/removes the user location marker based on the
     * current user lat/lng data.
     */
    LocationMap.prototype.updateUserMarker = function () {
        // If we have a user marker and need to remove it, do so
        if (this.userMarker && (this.userLat === null || this.userLng === null)) {
            this.userMarker.setMap(null);
            this.userMarker = null;
        } else if (!this.userMarker) {
            // We don't have a marker yet, so add one
            this.userMarker = new google.maps.Marker({
                position: new google.maps.LatLng(this.userLat, this.userLng),
                map: this.map,
                optimized: false,
                icon: this.icons.user,
                animation: google.maps.Animation.DROP
            });
        } else {
            // Update the existing user marker
            this.userMarker.setPosition(
                new google.maps.LatLng(this.userLat, this.userLng)
            );
        }
    };

    /**
     * Sets the map center lat/lng, used to determine which Co-Op ATMs are
     * returned when fetching location data (if applicable).
     * 
     * @param {number} lat 
     * @param {number} lng 
     */
    LocationMap.prototype.setMapCenterCoords = function (lat, lng) {
        this.mapCenterLat = lat;
        this.mapCenterLng = lng;
    };

    // Return our LocationMap function so we can use it outside the current scope
    return LocationMap;

})(jQuery);
